import { Button } from "@/components/ui/button";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { TrashIcon } from "@heroicons/react/outline";
import { BracesIcon, PencilLine } from "lucide-react";
import { MetadataItem } from "../types";
import InputField from "./InputField";
import JsonTextArea from "./JsonTextArea";

const MetadataItemRow = ({
  item,
  isJsonMode,
  onKeyChange,
  onValueChange,
  onToggleJsonMode,
  onDelete,
}: {
  item: MetadataItem;
  isJsonMode: boolean;
  onKeyChange: (value: string) => void;
  onValueChange: (value: string) => void;
  onToggleJsonMode: () => void;
  onDelete: () => void;
}) =>
  item.key !== "markdown_enabled" && (
    <div className="flex items-start gap-2">
      <div className="w-1/3">
        <InputField
          value={item.key}
          placeholder="Key"
          onChange={onKeyChange}
          className="w-full"
        />
      </div>

      <div className="flex-1">
        {isJsonMode ? (
          <JsonTextArea value={item.value} onChange={onValueChange} />
        ) : (
          <InputField
            value={item.value}
            placeholder="Value"
            onChange={onValueChange}
            className="w-full"
          />
        )}
      </div>

      <div className="flex shrink-0 items-start gap-1">
        <BasicTooltip
          content={isJsonMode ? "Switch to text mode" : "Switch to JSON mode"}
        >
          <Button
            size="sm"
            variant="outline"
            onClick={onToggleJsonMode}
            className="h-9"
          >
            {isJsonMode ? (
              <PencilLine className="h-3 w-3" />
            ) : (
              <BracesIcon className="h-3 w-3" />
            )}
          </Button>
        </BasicTooltip>
        <BasicTooltip content="Delete item">
          <Button
            size="sm"
            variant="destructiveOutline"
            onClick={onDelete}
            className="h-9"
          >
            <TrashIcon className="h-3 w-3" />
          </Button>
        </BasicTooltip>
      </div>
    </div>
  );

export default MetadataItemRow;
